import { Environment } from './environment.interface';
import { baseEnvironment } from './environment.base';

/**
 * Test Environment Configuration
 *
 * Configuration for test environment.
 * Uses test/staging API endpoints and services.
 */

export const environment: Environment = {
  ...baseEnvironment,
  production: false,
  environmentName: 'test',
  apiEndpoints: {
    gatewayBaseUrl: 'https://test.api.smartlinks.dev',
    // TEMPORARY (#173533): Events served from the developer's machine so the deployed test admin reads its Firestore sales. Lives only on feature/SP20-173533-events-admin-local-bridge; never merge.
    eventsApiBaseUrl: 'http://localhost:3000/api'
  },
} as Environment;
